// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"6ed48f76","868":"52956c02"}[chunkId] + ".chunk.js";
};